import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';

export const SportLabelWrapper = styled('div', { label: 'SportLabelWrapper' })`
    width: 180px;
    margin-right: 8px;
`;

export const SportLabel = styled('p', { label: 'SportLabel' })`
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    color: ${mainColors.main.primary};
    margin: 0;
`;

export const SportSlug = styled('p', { label: 'SportSlug' })`
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    color: ${mainColors.grays.gray300};
    margin: 0;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 8px;
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
    margin-left: 8px;
    align-self: center;
`;

export const CheckboxWrapper = styled('div', { label: 'CheckboxWrapper' })`
    display: flex;
    margin-right: 16px;
`;
